
import Vue from 'vue'
import PageTitle from '@/components/PageTitle.vue'
import SchoolBreadcrumb from './SchoolBreadcrumb.vue'

export default Vue.extend({
   name: 'SchoolSettingsPageHeader',
   props: {
      crumbs: { type: Array as () => Breadcrumb[], default: () => [] },
      includeSchool: { type: Boolean, default: true },
      title: { type: String, default: '' },
   },
   computed: {
      pageTitle(): string {
         if (this.title.length > 0) {
            return this.title
         }
         const lastCrumb = this.crumbs.last
         return lastCrumb ? lastCrumb.text : ''
      },
   },
   components: {
      PageTitle,
      SchoolBreadcrumb,
   },
})
